import { fetchJSON, stringifyParams } from 'utils/req'

export const postImport = importInfo =>
  fetchJSON('/api/v1/imports', 'POST', { import: importInfo }, { useJwt: true })

export const fetchImports = params =>
  fetchJSON(`/api/v1/imports?${stringifyParams(params)}`, 'GET', null, {
    useJwt: true,
  })
